import { useEffect, useState } from 'react';
import HeaderMaster from '../components/HeaderMaster';
import SideBarMaster from '../components/SideBarMaster';
import FooterNavigationMaster from '../components/FooterNavigationMaster';
import styles from './VisaoGeralMaster.module.css';
import { MdSchool, MdStore, MdPeople, MdShoppingCart } from "react-icons/md";

function VisaoGeralMaster() {
    const [estatisticas, setEstatisticas] = useState({
        totalUniversidades: 0,
        lanchonetesAtivas: 0,
        lanchonetesInativas: 0,
        totalPedidos: 0,
        totalClientes: 0,
        totalAdministradores: 0
    });

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEstatisticas = async () => {
            try {
                const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
                const token = localStorage.getItem('token');

                const response = await fetch(`${API_URL}/master/estatisticas`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`Erro ao buscar estatísticas: ${response.status}`);
                }

                const data = await response.json();
                setEstatisticas(data);
                setLoading(false);
            } catch (error) {
                console.error("Erro ao buscar estatísticas:", error.message);
                setLoading(false);
            }
        };

        fetchEstatisticas();
    }, []);

    const totalUsuarios = estatisticas.totalClientes + estatisticas.totalAdministradores;
    const totalEstabelecimentos = estatisticas.lanchonetesAtivas + estatisticas.lanchonetesInativas;
    const percentualAtivos = totalEstabelecimentos > 0
        ? (estatisticas.lanchonetesAtivas / totalEstabelecimentos) * 100
        : 0;

    return (
        <div className={styles.secaoPrincipal}>
            <SideBarMaster />

            <div className={styles.containerDashboard}>
                <HeaderMaster />

                <div className={styles.contentDashboard}>

                    <div className={styles.tituloSecao}>
                        <h2>Visão Geral do Sistema</h2>
                    </div>

                    <section className={styles.resumoDashboard}>

                        <div className={styles.cardEstatistica}>
                            <div className={styles.cardTop}>
                                <div className={styles.cardIcon}>
                                    <MdSchool />
                                </div>
                            </div>
                            <div className={styles.cardContent}>
                                <h3>Universidades Cadastradas</h3>
                                <p className={styles.numero}>
                                    {loading ? '...' : estatisticas.totalUniversidades}
                                </p>
                            </div>
                        </div>

                        <div className={styles.cardEstatistica}>
                            <div className={styles.cardTop}>
                                <div className={styles.cardIcon}>
                                    <MdStore />
                                </div>
                            </div>
                            <div className={styles.cardContent}>
                                <h3>Lanchonetes Ativas</h3>
                                <p className={styles.numero}>
                                    {loading ? '...' : estatisticas.lanchonetesAtivas}
                                </p>
                                <span className={styles.subtexto}>
                                    {estatisticas.lanchonetesInativas} inativas
                                </span>
                            </div>
                        </div>

                        <div className={styles.cardEstatistica}>
                            <div className={styles.cardTop}>
                                <div className={styles.cardIcon}>
                                    <MdShoppingCart />
                                </div>
                            </div>
                            <div className={styles.cardContent}>
                                <h3>Total de Pedidos</h3>
                                <p className={styles.numero}>
                                    {loading ? '...' : estatisticas.totalPedidos}
                                </p>
                                <span className={styles.subtexto}>realizados no app</span>
                            </div>
                        </div>

                        <div className={styles.cardEstatistica}>
                            <div className={styles.cardTop}>
                                <div className={styles.cardIcon}>
                                    <MdPeople />
                                </div>
                            </div>
                            <div className={styles.cardContent}>
                                <h3>Usuários Cadastrados</h3>
                                <p className={styles.numero}>
                                    {loading ? '...' : totalUsuarios}
                                </p>
                                <span className={styles.subtexto}>
                                    {estatisticas.totalClientes} clientes · {estatisticas.totalAdministradores} admins
                                </span>
                            </div>
                        </div>

                    </section>

                    <section className={styles.infoAdicional}>

                        <div className={styles.boxInfo}>
                            <h3>Detalhamento de Estabelecimentos</h3>
                            <div className={styles.barraProgresso}>
                                <div
                                    className={styles.progressoAtivos}
                                    style={{ width: `${percentualAtivos}%` }}
                                />
                            </div>
                            <div className={styles.legendaProgresso}>
                                <span className={styles.ativo}>Ativos: {estatisticas.lanchonetesAtivas}</span>
                                <span className={styles.inativo}>Inativos: {estatisticas.lanchonetesInativas}</span>
                            </div>
                        </div>

                        <div className={styles.boxInfo}>
                            <h3>Distribuição de Usuários</h3>
                            <div className={styles.usuariosGrid}>
                                <div className={styles.usuarioCard}>
                                    <span className={styles.label}>Clientes</span>
                                    <span className={styles.valor}>
                                        {loading ? '...' : estatisticas.totalClientes}
                                    </span>
                                </div>
                                <div className={styles.usuarioCard}>
                                    <span className={styles.label}>Administradores</span>
                                    <span className={styles.valor}>
                                        {loading ? '...' : estatisticas.totalAdministradores}
                                    </span>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
            </div>

            <FooterNavigationMaster />
        </div>
    );
}

export default VisaoGeralMaster;